/* eslint-disable object-curly-newline */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";
import { setLocalValue, removeLocalValue } from "../storage";
import WindowOpener, { LMWindow } from "../windowOpener";
import { logout } from "../authorization/Authorization";
import { router } from "../hook/useRouterNavigation";
import { setLmWindow } from "../hook/useWindowStateHelper";

const FUNCTION_ID_ELEARNING = "1";
const FUNCTION_ID_SUBMIT_TASK = "2";
const FUNCTION_ID_ANSWER_QUESTIONNAIRE = "3";
const FUNCTION_ID_MANAGER = "5";
const PORTAL_FLG = "0";
const OPEN_TYPE_OPEN = "0";
const OPEN_TYPE_TRANSITION = "1";

interface LmFunctionPayload {
    funcID: string;
    param?: object;
}

export interface ELearningPayload {
    career_id: string;
    class_id: string;
}

export interface SubmitTaskPayload {
    career_id: string;
    class_id: string;
    flg: string;
    seq: string;
    subjectStatusflg: string;
}

export interface AnswerQuestionnairePayload {
    career_id: string;
    class_id: string;
    questionnaire_id: string;
    type: string;
    flg: string;
}

interface LmFunctionELearningPayload extends LmFunctionPayload {
    param: ELearningPayload;
}

interface LmFunctionSubmitTaskPayload extends LmFunctionPayload {
    param: SubmitTaskPayload;
}
interface LmFunctionAnswerQuestionnairePayload extends LmFunctionPayload {
    param: AnswerQuestionnairePayload;
}

interface Lminfo {
    secureToken: string;
    loginID: string;
    authorityList: Array<string>;
    langCd: string;
    locale: string;
    userId: string;
    managerChk: string;
    CM_ENABLED: string;
    CM_SKILLMAP_ENABLED: string;
    CAREER_TYPE_CONTROL: string;
    USE_JINJI_ZOKUSEI: string;
    QM_APPLICATION_CHECK_NUMBER: string;
    QM_CAREER_NUMBER: string;
    multiTenantMode: string;
    lmLoginPath: string;
    lmPreviewPath: string;
}

interface LmFunctionResponse {
    funcUrl: string;
    lminfo: Lminfo;
}

class LmFunctionService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "lmFunction");
    }

    private static setLocalStorage(funcID: string, lminfo: Lminfo, mobile?: boolean): void {
        const { href } = window.location;
        setLocalValue("portalFlg", PORTAL_FLG);
        setLocalValue("token", lminfo.secureToken);
        setLocalValue("loginID", lminfo.loginID);
        const userAttributes = {
            authorityList: lminfo.authorityList,
            lang: lminfo.langCd,
            locale: lminfo.locale,
            userId: lminfo.userId,
            managerChk: lminfo.managerChk,
            loginType: "",
        };
        setLocalValue("userAttr", JSON.stringify(userAttributes));
        setLocalValue("CM_ENABLED", lminfo.CM_ENABLED);
        setLocalValue("CM_SKILLMAP_ENABLED", lminfo.CM_SKILLMAP_ENABLED);
        setLocalValue("CAREER_TYPE_CONTROL", lminfo.CAREER_TYPE_CONTROL);
        setLocalValue("USE_JINJI_ZOKUSEI", lminfo.USE_JINJI_ZOKUSEI);
        setLocalValue("QM_APPLICATION_CHECK_NUMBER", lminfo.QM_APPLICATION_CHECK_NUMBER);
        setLocalValue("QM_CAREER_NUMBER", lminfo.QM_CAREER_NUMBER);
        setLocalValue("multiTenantMode", lminfo.multiTenantMode);

        // PCの場合はopenTypeに0、モバイルの場合は1を設定する。
        const openType = !mobile ? OPEN_TYPE_OPEN : OPEN_TYPE_TRANSITION;
        setLocalValue("openType", openType);

        // openTypeに従って、portalReturnUrlDataを設定
        if (openType !== OPEN_TYPE_TRANSITION) {
            // openType:0 → 何もしない
            return;
        }
        // openType:1 → portalReturnUrlDataを設定
        const portalReturnUrlData = {
            // 遷移元画面のURLを設定
            migrateUrl: href,
            // ポータルのログイン画面のURLを設定
            portalLoginUrl: href.substring(0, href.indexOf("#")),
        };
        setLocalValue("portalReturnUrlData", JSON.stringify(portalReturnUrlData));
    }

    private static clearLocalStorage() {
        removeLocalValue("portalFlg");
        removeLocalValue("token");
        removeLocalValue("loginID");
        removeLocalValue("userAttr");
        removeLocalValue("CM_ENABLED");
        removeLocalValue("CM_SKILLMAP_ENABLED");
        removeLocalValue("CAREER_TYPE_CONTROL");
        removeLocalValue("USE_JINJI_ZOKUSEI");
        removeLocalValue("QM_APPLICATION_CHECK_NUMBER");
        removeLocalValue("QM_CAREER_NUMBER");
        removeLocalValue("multiTenantMode");
        removeLocalValue("openType");
        removeLocalValue("portalReturnUrlData");
    }

    private async lmFunction(
        payload: LmFunctionPayload,
        onOpen: (sub: LMWindow, response: LmFunctionResponse) => void,
        rejected: (error: any) => void,
        mobile?: boolean
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as LmFunctionResponse;
                LmFunctionService.setLocalStorage(payload.funcID, response.lminfo, mobile);
                if (!mobile) {
                    // PC版
                    const sub = WindowOpener.open(
                        response.funcUrl,
                        // LM画面を開いた際の処理
                        (_sub) => {
                            // 対象のオリジンを指定するためにURLのプロトコルとホストの文字列を取得する。
                            const { protocol, host } = window.location;

                            // イベントリスナーに設定する処理
                            const handler = (event: MessageEvent<any>) => {
                                // メッセージの送信元が対象のオリジン([プロトコル]+//+[ホスト])以外はreturnする。
                                if (event.origin !== `${protocol}//${host}`) return;

                                // logout：LM画面でログアウトした場合、ポータル側でログアウト処理＆ログイン画面に遷移する。
                                if (event.data === "logout") {
                                    logout();
                                    router("/");
                                    window.removeEventListener("message", handler);
                                }
                            };
                            window.addEventListener("message", handler);

                            // ポータル側でLM画面を閉じられるように、ウィンドウ情報をグローバル変数にセットしておく。
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            setLmWindow(_sub);
                        },
                        () => {
                            // LM側のタブが閉じた際はポータル側の画面をリロードする。
                            LmFunctionService.clearLocalStorage();
                            setLmWindow(null);
                            window.location.reload();
                        }
                    );
                    if (sub) {
                        onOpen(sub, response);
                    }
                } else {
                    // モバイル版
                    window.location.href = response.funcUrl;
                }
            },
            rejected
        );
    }

    public async openELearning(payload: ELearningPayload, rejected: (error: any) => void, mobile: boolean) {
        await this.lmFunction(
            {
                funcID: FUNCTION_ID_ELEARNING,
                param: payload,
            } as LmFunctionELearningPayload,
            () => {
                // NOP.
            },
            rejected,
            mobile
        );
    }

    public async openSubmitTask(payload: SubmitTaskPayload, rejected: (error: any) => void, mobile: boolean) {
        await this.lmFunction(
            {
                funcID: FUNCTION_ID_SUBMIT_TASK,
                param: payload,
            } as LmFunctionSubmitTaskPayload,
            () => {
                // NOP.
            },
            rejected,
            mobile
        );
    }

    public async openAnswerQuestionnaire(payload: AnswerQuestionnairePayload, rejected: (error: any) => void, mobile: boolean) {
        await this.lmFunction(
            {
                funcID: FUNCTION_ID_ANSWER_QUESTIONNAIRE,
                param: payload,
            } as LmFunctionAnswerQuestionnairePayload,
            () => {
                // NOP.
            },
            rejected,
            mobile
        );
    }

    public async openManager(rejected: (error: any) => void) {
        await this.lmFunction(
            {
                funcID: FUNCTION_ID_MANAGER,
            } as LmFunctionPayload,
            (sub: LMWindow, response: LmFunctionResponse) => {
                setTimeout(() => {
                    sub.lmLoginPath = response.lminfo.lmLoginPath;
                    sub.lmPreviewPath = response.lminfo.lmPreviewPath;
                }, 1000);
            },
            rejected
        );
    }
}

export default LmFunctionService;
